import { type FC, type PropsWithChildren, createContext, useContext, useMemo } from 'react'

type LocatorLockerConfig = {
  baseUrl: string
}

type Props = {
  baseUrl: string
}

const LocatorLockerConfigContext = createContext<LocatorLockerConfig | undefined>(undefined)

export const useLocatorLockerConfigContext = (): LocatorLockerConfig | undefined =>
  useContext(LocatorLockerConfigContext)

export const LocatorLockerConfigProvider: FC<PropsWithChildren<Props>> = ({ children, baseUrl }) => {
  const value = useMemo(() => ({ baseUrl }), [baseUrl])

  return <LocatorLockerConfigContext.Provider value={value}>{children}</LocatorLockerConfigContext.Provider>
}
